<template lang="pug">
  h1 About
</template>

<script>
export default {
  name: 'About',
};
</script>
